import React, { createContext, useContext, ReactNode } from 'react';
import { useLoading } from '../../hooks/useLoading';

interface LoadingContextType {
  isLoading: boolean;
  startLoading: () => void;
  stopLoading: () => void;
  withLoading: <T>(asyncFunction: () => Promise<T>, delay?: number) => Promise<T>;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

interface LoadingProviderProps {
  children: ReactNode;
  delay?: number;
}

export const LoadingProvider: React.FC<LoadingProviderProps> = ({ 
  children, 
  delay = 400 
}) => {
  const loadingState = useLoading(delay);

  return (
    <LoadingContext.Provider value={loadingState}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoadingContext = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error('useLoadingContext debe ser usado dentro de un LoadingProvider');
  }
  return context;
};
